var _circle, _circle2, _circle3, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSignCircles(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 148,
    height: 342,
    viewBox: "0 0 148 342",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 62.4193,
    cy: 255.087,
    r: 36.6899,
    transform: "rotate(15 62.4193 255.087)",
    stroke: "black"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    r: 1.89744,
    transform: "matrix(-0.965926 -0.258819 -0.258819 0.965926 27.5228 266.558)",
    fill: "black"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    r: 1.89744,
    transform: "matrix(-0.965926 -0.258819 -0.258819 0.965926 62.39 218.541)",
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-95.4071 294.265C-24.0729 313.379 49.2499 271.046 68.3639 199.712C87.4778 128.378 45.1449 55.0551 -26.1894 35.9412C-97.5236 16.8272 -170.846 59.1601 -189.96 130.494C-209.074 201.829 -166.741 275.151 -95.4071 294.265ZM-95.666 295.231C-23.7982 314.488 50.0729 271.839 69.3298 199.971C88.5867 128.103 45.9372 54.2322 -25.9305 34.9753C-97.7983 15.7183 -171.669 58.3679 -190.926 130.236C-210.183 202.103 -167.534 275.974 -95.666 295.231Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignCircles);
export default __webpack_public_path__ + "static/media/SignCircles.7b8beec1b170da3d310481ee7c54a9af.svg";
export { ForwardRef as ReactComponent };